import { gql } from '@apollo/client';

export const PAGED_LEASING_INTEREST_TYPE_DETAILS_QUERY = gql`
  query pagedLeasingInterestTypeDetails($pager: PagerInputNew, $filters: LeasingInterestTypeDetailFilterInput) {
    pagedLeasingInterestTypeDetails(pager: $pager, filters: $filters) {
      total
      values {
        interestTypeDetailId
        interestTypeId
        interestTypeName
        startDate
        endDate
        interestPercent
        currencyId
        currencyCode
      }
    }
  }
`;
